/** 1=tam slider 2=slider+yan liste 3=grid 4=kompakt slider 5=ortada slider+4 yan kart 6=slider+sağda 2 kart */
export const MASTHEAD_LAYOUT = {
  SLIDER: 1,
  SLIDER_SIDEBAR: 2,
  GRID: 3,
  COMPACT_SLIDER: 4,
  CENTER_SIDES: 5,
  SLIDER_RIGHT: 6,
} as const

export type MastheadLayoutId =
  (typeof MASTHEAD_LAYOUT)[keyof typeof MASTHEAD_LAYOUT]

export const MASTHEAD_LAYOUT_OPTIONS: ReadonlyArray<{
  value: MastheadLayoutId
  label: string
  description: string
}> = [
  {
    value: MASTHEAD_LAYOUT.SLIDER,
    label: 'Tam Slider',
    description: 'Geniş tam genişlik slider',
  },
  {
    value: MASTHEAD_LAYOUT.SLIDER_SIDEBAR,
    label: 'Slider + Yan Liste',
    description: 'Slider ve yanında haber listesi',
  },
  {
    value: MASTHEAD_LAYOUT.GRID,
    label: 'Grid Manşet',
    description: 'Büyük görsel + 4 küçük kart',
  },
  {
    value: MASTHEAD_LAYOUT.COMPACT_SLIDER,
    label: 'Kompakt Slider',
    description: 'Daha kısa slider (ana sayfa için ideal)',
  },
  {
    value: MASTHEAD_LAYOUT.CENTER_SIDES,
    label: 'Ana Manşet',
    description: 'Ortada slider, sağ ve solda 2\'şer haber',
  },
  {
    value: MASTHEAD_LAYOUT.SLIDER_RIGHT,
    label: 'Slider + Sağ Kartlar',
    description: 'Slider ve sağında 2 haber kartı',
  },
]

export function resolveMastheadLayout(
  raw: number | null | undefined,
  surface: 'home' | 'category',
): MastheadLayoutId {
  const value = Number(raw)
  if (value >= 1 && value <= 6) return value as MastheadLayoutId
  return surface === 'home'
    ? MASTHEAD_LAYOUT.COMPACT_SLIDER
    : MASTHEAD_LAYOUT.SLIDER_SIDEBAR
}

export function parseMastheadLayout(
  value: number | string,
  fallback: MastheadLayoutId = MASTHEAD_LAYOUT.COMPACT_SLIDER,
): MastheadLayoutId {
  const n = Number(value)
  if (n >= 1 && n <= 6) return n as MastheadLayoutId
  return fallback
}
